var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"prescription"},[_c('BarCode',{attrs:{"barList":_vm.barList}}),(_vm.list.prescriptionImage)?_c('img',{attrs:{"src":_vm.insuranceImage,"alt":""}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }